import React, { useEffect } from "react";
import { Container, Row, Col, Button, Breadcrumb } from "react-bootstrap";
import { getHealthInsurance } from "../../../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import moment from "moment";

const ViewHealthIndex = () => {
  const { editId } = useParams();
  const dispatch = useDispatch();
  const InsuranceData = useSelector((s) => s.Signatures?.getInsurance?.data);
  console.log(
    "🚀 ~ file: ViewFacebookMessageIndex.jsx:11 ~ ViewHealthIndex ~ InsuranceData:",
    InsuranceData
  );

  useEffect(() => {
    dispatch(getHealthInsurance(editId));
  }, [editId]);
  return (
    <>
      <section className="dashboard profile-main py-2">
        <Container>
          <Row>
            <Col lg="12" className="my-2">
              <div className="top mb-2">
                <Breadcrumb>
                  <Breadcrumb.Item href="/health-insurance">
                    Health Insurance
                  </Breadcrumb.Item>
                  <Breadcrumb.Item active>Details</Breadcrumb.Item>
                </Breadcrumb>
              </div>
            </Col>
          </Row>
          <div className="bg-white px-4 py-3 card-box">
            <Row>
              <Col lg="6" className="my-2">
                <label htmlFor="" className="form-label2 m-0">
                  Name
                </label>
                <input
                  type="text"
                  value={InsuranceData?.name}
                  className="form-control text-capitalize"
                  disabled
                />
              </Col>
              <Col lg="6" className="my-2">
                <label htmlFor="" className="form-label2 m-0">
                  Email
                </label>
                <input
                  type="text"
                  value={InsuranceData?.email}
                  className="form-control"
                  disabled
                />
              </Col>
            </Row>
            <Row>
              <Col lg="6" className="my-2">
                <label htmlFor="" className="form-label2 m-0">
                  Weight
                </label>
                <input
                  type="text"
                  value={InsuranceData?.weight}
                  className="form-control"
                  disabled
                />
              </Col>
              <Col lg="6" className="my-2">
                <label htmlFor="" className="form-label2 m-0">
                  Height
                </label>
                <input
                  type="text"
                  value={InsuranceData?.height}
                  className="form-control text-capitalize"
                  disabled
                />
              </Col>
            </Row>
            <Row>
              <Col lg="6" className="my-2">
                <label htmlFor="" className="form-label2 m-0">
                  Date of birth
                </label>
                <input
                  type="text"
                  value={moment(InsuranceData?.health_insurance_dob).format(
                    "DD/MM/YYYY"
                  )}
                  className="form-control text-capitalize"
                  disabled
                />
              </Col>
              <Col lg="6" className="my-2">
                <label htmlFor="" className="form-label2 m-0">
                  State
                </label>
                <input
                  type="text"
                  value={InsuranceData?.state}
                  className="form-control"
                  disabled
                />
              </Col>
            </Row>
            <Row>
              <Col lg="6" className="my-2">
                <label htmlFor="" className="form-label2 m-0">
                  Address
                </label>
                <input
                  type="text"
                  value={InsuranceData?.address}
                  className="form-control"
                  disabled
                />
              </Col>
              <Col lg="6" className="my-2">
                <label htmlFor="" className="form-label2 m-0">
                  City
                </label>
                <input
                  type="text"
                  value={InsuranceData?.city}
                  className="form-control text-capitalize"
                  disabled
                />
              </Col>
            </Row>
            <div className="top my-3">
              <h4 className="dashboard-head m-0">Comments</h4>
            </div>
            <Row className="radio-wrp mt-3">
              <textarea
                className="form-control"
                value={InsuranceData?.comments}
                cols="20"
                rows="7"
                disabled
              ></textarea>
            </Row>
          </div>
        </Container>
      </section>
    </>
  );
};
export default ViewHealthIndex;
